// src/pages/admin/AdminLayout.jsx

import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { logoutAdmin, isAdminLoggedIn } from "./auth";
import {
  FaBars,
  FaHome,
  FaBlog,
  FaUser,
  FaBriefcase,
  FaChartBar,
  FaSignOutAlt,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import oakyaLogo from "../../assets/contactBlogCareer/oakya-it-services.webp";

const AdminLayout = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  // Check if admin is logged in
  if (!isAdminLoggedIn()) {
    navigate("/admin-control-panel/admin-login", { replace: true });
    return null;
  }

const handleLogout = () => {
  logoutAdmin();
  toast.success("Logged out successfully");
  navigate("/admin-control-panel/admin-login", { replace: true });
};

  const headerHeight = 60;
  const sidebarWidth = open ? 240 : 70;

  return (
    <div style={{ minHeight: "100vh", background: "#f5f7fb" }}>

      {/* HEADER */}
      <div
        style={{
          height: `${headerHeight}px`,
          background: "#111827",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img
            src={oakyaLogo}
            alt="Oakya"
            style={{ width: 30, height: 30, objectFit: "contain" }}
          />
          <h3 style={{ margin: 0 }}>Oakya Admin Panel</h3>
        </div>
      </div>

      {/* TOGGLE BUTTON */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          position: "fixed",
          top: `${headerHeight + 15}px`,
          left: `${sidebarWidth - 18}px`,
          width: 36,
          height: 36,
          borderRadius: "50%",
          background: "#111827",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          zIndex: 1100,
        }}
      >
        <FaBars size={14} />
      </div>

      <div style={{ display: "flex", marginTop: `${headerHeight}px` }}>

        {/* SIDEBAR */}
        <div
          style={{
            width: `${sidebarWidth}px`,
            background: "#111827",
            color: "#fff",
            height: `calc(100vh - ${headerHeight}px)`,
            position: "fixed",
            left: 0,
            top: `${headerHeight}px`,
            transition: "0.3s",
          }}
        >
          <nav style={{ padding: "15px 10px", display: "flex", flexDirection: "column", gap: "8px" }}>

            <NavLink
              to="/admin-control-panel/dashboard"
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px",
                borderRadius: "8px",
                textDecoration: "none",
                color: isActive ? "#fff" : "#cbd5e1",
                background: isActive ? "#4f46e5" : "transparent",
              })}
            >
              <FaHome />
              {open && "Dashboard"}
            </NavLink>

            <NavLink
              to="/admin-control-panel/create-blog"
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px",
                borderRadius: "8px",
                textDecoration: "none",
                color: isActive ? "#fff" : "#cbd5e1",
                background: isActive ? "#4f46e5" : "transparent",
              })}
            >
              <FaBlog />
              {open && "Create Blog"}
            </NavLink>

            <NavLink
              to="/admin-control-panel/create-career"
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px",
                borderRadius: "8px",
                textDecoration: "none",
                color: isActive ? "#fff" : "#cbd5e1",
                background: isActive ? "#4f46e5" : "transparent",
              })}
            >
              <FaBriefcase />
              {open && "Create Career"}
            </NavLink>

            <NavLink
              to="/admin-control-panel/job-applicants"
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px",
                borderRadius: "8px",
                textDecoration: "none",
                color: isActive ? "#fff" : "#cbd5e1",
                background: isActive ? "#4f46e5" : "transparent",
              })}
            >
              <FaUser />
              {open && "Job Applicants"}
            </NavLink>

            <NavLink
              to="/admin-control-panel/blog-visit"
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px",
                borderRadius: "8px",
                textDecoration: "none",
                color: isActive ? "#fff" : "#cbd5e1",
                background: isActive ? "#4f46e5" : "transparent",
              })}
            >
              <FaChartBar />
              {open && "Blog Reports"}
            </NavLink>

          </nav>

          {/* LOGOUT */}
          <button
            onClick={handleLogout}
            style={{
              position: "absolute",
              bottom: 15,
              left: 10,
              right: 10,
              padding: "12px",
              background: "#dc2626",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: open ? "flex-start" : "center",
              gap: "10px",
            }}
          >
            <FaSignOutAlt />
            {open && "Logout"}
          </button>
        </div>

        {/* MAIN CONTENT */}
        <div style={{ marginLeft: `${sidebarWidth}px`, flex: 1, padding: "20px" }}>
          <Outlet />
        </div>

      </div>
      <ToastContainer
  position="top-right"
  autoClose={2000}
  pauseOnHover
/>
    </div>
  );
};

export default AdminLayout;